export enum StatesEnum {
  AC = 'AC',
  AL = 'AL',
  AP = 'AP',
  AM = 'AM',
  BA = 'BA',
  CE = 'CE',
  DF = 'DF',
  ES = 'ES',
  GO = 'GO',
  MA = 'MA',
  MT = 'MT',
  MS = 'MS',
  MG = 'MG',
  PA = 'PA',
  PB = 'PB',
  PR = 'PR',
  PE = 'PE',
  PI = 'PI',
  RJ = 'RJ',
  RN = 'RN',
  RS = 'RS',
  RO = 'RO',
  RR = 'RR',
  SC = 'SC',
  SP = 'SP',
  SE = 'SE',
  TO = 'TO',
}

export enum DocumentTypeEnum {
  'Pessoa Física (CPF)' = 'CPF',
  'Pessoa Jurídica (CNPJ)' = 'CNPJ',
}

export enum DestinationEnum {
  "Arraial d'Ajuda" = "Arraial d'Ajuda",
  'Caraíva' = 'Caraíva',
  'Porto Seguro' = 'Porto Seguro',
  'Trancoso' = 'Trancoso',
  'Vale Verde' = 'Vale Verde',
  'Centro Histórico' = 'Centro Histórico',
  'Litoral Norte' = 'Litoral Norte',
}

export const states = Object.entries(StatesEnum).map(([key, value]) => ({
  label: key,
  value: value,
}));

export const destination = Object.entries(DestinationEnum).map(([key, value]) => ({
  label: key,
  value: value,
}));

export const documentTypes = Object.entries(DocumentTypeEnum).map(([key, value]) => ({
  label: key,
  value: value,
}));

export interface StatesSelectProps {
  field: {
    name: string;
    value: StatesEnum;
    onChange: (value: StatesEnum) => void;
    onBlur: () => void;
  };
  form: {
    values: any;
    setFieldValue: (field: string, value: StatesEnum) => void;
  };
}
[];

export interface DocumentTypeSelectProps {
  field: {
    name: string;
    value: DocumentTypeEnum;
    onChange: (value: DocumentTypeEnum) => void;
    onBlur: () => void;
  };
  form: {
    setFieldValue: (field: string, value: DocumentTypeEnum) => void;
  };
}
[];

export const validateCPF = (cpf: string): boolean => {
  cpf = cpf.replace(/[^\d]+/g, ''); // Remove caracteres não numéricos

  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
    return false; // Verifica se o CPF tem 11 dígitos e não é composto por todos os dígitos iguais
  }

  let sum;
  let remainder;

  // Validação do primeiro dígito verificador
  sum = 0;
  for (let i = 1; i <= 9; i++) {
    sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
  }
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) {
    remainder = 0;
  }
  if (remainder !== parseInt(cpf.substring(9, 10))) {
    return false;
  }

  // Validação do segundo dígito verificador
  sum = 0;
  for (let i = 1; i <= 10; i++) {
    sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
  }
  remainder = (sum * 10) % 11;
  if (remainder === 10 || remainder === 11) {
    remainder = 0;
  }
  if (remainder !== parseInt(cpf.substring(10, 11))) {
    return false;
  }

  return true;
};

export const validateCNPJ = (cnpj: string): boolean => {
  cnpj = cnpj.replace(/[^\d]+/g, ''); // Remove caracteres não numéricos

  if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) {
    return false; // Verifica se o CNPJ tem 14 dígitos e não é composto por todos os dígitos iguais
  }

  let length = cnpj.length - 2;
  let numbers = cnpj.substring(0, length);
  const digits = cnpj.substring(length);
  let sum = 0;
  let pos = length - 7;

  for (let i = length; i >= 1; i--) {
    sum += parseInt(numbers.charAt(length - i)) * pos--;
    if (pos < 2) pos = 9;
  }

  let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== parseInt(digits.charAt(0))) {
    return false;
  }

  length = length + 1;
  numbers = cnpj.substring(0, length);
  sum = 0;
  pos = length - 7;

  for (let i = length; i >= 1; i--) {
    sum += parseInt(numbers.charAt(length - i)) * pos--;
    if (pos < 2) pos = 9;
  }

  result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
  if (result !== parseInt(digits.charAt(1))) {
    return false;
  }

  return true;
};

export const validateDocument = (document: string, type: DocumentTypeEnum): boolean => {
  if (type === DocumentTypeEnum['Pessoa Física (CPF)']) {
    return validateCPF(document);
  } else if (type === DocumentTypeEnum['Pessoa Jurídica (CNPJ)']) {
    return validateCNPJ(document);
  }
  return false;
};
